// useInactivityLogout.js
import { useEffect, useRef } from "react";
import Cookies from "js-cookie";

const useInactivityLogout = (onLogout, timeout = 60 * 60 * 1000) => {
  const timerRef = useRef();

  const resetTimer = () => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      // Auto-logout after timeout
      onLogout();
    }, timeout);
  };

  useEffect(() => {
    const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];

    events.forEach((event) => window.addEventListener(event, resetTimer));
    resetTimer(); // start timer on mount

    return () => {
      clearTimeout(timerRef.current);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, []);
};

export default useInactivityLogout;
